import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import classnames from 'classnames';
import ErrorBoundary from '@sbt-web/error-boundary';
import { FeatureURI, type AdItem } from '@sbt-web/network/types';
import { wholeNumber } from '@sbt-web/utils';
import { AdReplyButtons } from '@/client/components/Detail/AdReply/components/AdReplyButtons';
import { IncreaseVisibilityButton } from '@/client/components/Detail/IncreaseVisibilityButton';
import { getTransactionFlows } from '@/shared/tools/transaction/utils';
import { getShowPhone } from '@/tools/phoneNumber/utils';
import useUser from '../../../../client/contexts/UserContext';
import { AdBuyEvent } from '../AdBuy';
import { AdBuyButtons } from '../AdBuy/components/AdBuyButtons';
import classes from './index.module.scss';
interface Props {
  item: AdItem;
}
const StickyBar = t0 => {
  const $ = _c(36);
  const {
    item
  } = t0;
  const advertiserId = item.advertiser.userId;
  const {
    urn,
    subject
  } = item;
  const [stickyHide, setStickyHide] = useState(false);
  const {
    user
  } = useUser();
  const userID = user?.id;
  const isMySelf = advertiserId === userID;
  let t1;
  if ($[0] !== item || $[1] !== userID) {
    t1 = getShowPhone(item, userID);
    $[0] = item;
    $[1] = userID;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const showPhone = t1;
  const priceFeature = item.features[FeatureURI.Price];
  let t2;
  if ($[3] !== priceFeature) {
    t2 = priceFeature ? wholeNumber.format(parseFloat(priceFeature.values[0].value)) : null;
    $[3] = priceFeature;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const price = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = eventName => {
      window.dispatchEvent(new CustomEvent(eventName));
      setStickyHide(true);
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const dispatchEventAndHideSticky = t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      dispatchEventAndHideSticky(AdBuyEvent.OpenOfferDialog);
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleTriggerAdOffer = t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      dispatchEventAndHideSticky(AdBuyEvent.OpenCartDialog);
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const handleTriggerAdBuyNow = t5;
  let t6;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      if (!window.IntersectionObserver) {
        return;
      }
      const anchor = document.querySelector(".sticky-cta-bottom-anchor");
      if (!anchor) {
        return;
      }
      const observer = new window.IntersectionObserver(t8 => {
        const [entry] = t8;
        setStickyHide(entry.isIntersecting || !entry.isIntersecting && entry.boundingClientRect.bottom <= 0);
      });
      observer.observe(anchor);
      return () => observer.disconnect();
    };
    t7 = [];
    $[8] = t6;
    $[9] = t7;
  } else {
    t6 = $[8];
    t7 = $[9];
  }
  useEffect(t6, t7);
  let t8;
  if ($[10] !== item || $[11] !== userID) {
    t8 = getTransactionFlows(item, userID);
    $[10] = item;
    $[11] = userID;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const transactionFlows = t8;
  const thereIsPlaceForContactButton = transactionFlows.length < 2;
  const isOnlyOneTransactionFlowsVisible = transactionFlows.length === 1;
  let t9;
  if ($[13] !== stickyHide) {
    t9 = classnames(classes.stickyContainer, {
      [classes.hide]: stickyHide
    });
    $[13] = stickyHide;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== subject) {
    t10 = <p className="body-text semibold">{subject}</p>;
    $[15] = subject;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== price) {
    t11 = price && <p className="body-text semibold">{price}</p>;
    $[17] = price;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10 || $[20] !== t11) {
    t12 = <div className={classes.nameAndPrice}>{t10}{t11}</div>;
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== isMySelf || $[23] !== isOnlyOneTransactionFlowsVisible || $[24] !== item || $[25] !== showPhone || $[26] !== thereIsPlaceForContactButton || $[27] !== urn || $[28] !== userID) {
    t13 = isMySelf ? <IncreaseVisibilityButton isMobile={false} adUrn={urn} /> : <>{thereIsPlaceForContactButton && <AdReplyButtons showPhone={showPhone} adUrn={urn} isMobile={false} item={item} contactAsSecondaryButton={isOnlyOneTransactionFlowsVisible} />}<AdBuyButtons buyNowButtonClasses={[classes.cta]} sendOfferButtonClasses={[classes.cta]} onBuyNowButtonClick={handleTriggerAdBuyNow} onSendOfferButtonClick={handleTriggerAdOffer} item={item} userId={userID} /></>;
    $[22] = isMySelf;
    $[23] = isOnlyOneTransactionFlowsVisible;
    $[24] = item;
    $[25] = showPhone;
    $[26] = thereIsPlaceForContactButton;
    $[27] = urn;
    $[28] = userID;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t12 || $[31] !== t13) {
    t14 = <div className={classes.stickyContent}>{t12}{t13}</div>;
    $[30] = t12;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t14 || $[34] !== t9) {
    t15 = <ErrorBoundary><div id="sticky-cta-container" className={t9}>{t14}</div></ErrorBoundary>;
    $[33] = t14;
    $[34] = t9;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  return t15;
};
export default StickyBar;
export type { Props };